<template>
  <div style="background:#FAFAFA;" class="policeLato">
    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section v-if="isDesktop()">
      <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
        <p class="paralax-cover-image-text">
        <div class="content_home" style="z-index: 1!important;">
          <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('sinistre.header_title[0]') }}</span></h1>
          <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('sinistre.header_title[1]') }}</span></h1>
        </div>
        </p>
      </div>
    </section>

    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section class="mt-5" v-if="isMobile()">
      <div class="paralax-cover-image_mobile has-background-dim_mobile">
        <p class="paralax-cover-image-text_mobile">
        <div class="content_home" style="z-index: 1!important;margin-top: 10%">
          <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('sinistre.header_title[0]') }}</span></h1>
          <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('sinistre.header_title[1]') }}</span></h1>
        </div>
        </p>
      </div>
    </section>

    <div>
      <div class="container" style="background: #FAFAFA">
        <div class="container justify-content-center row text-center mb-5 mt-5">
          <p v-show="NextStep" v-if="vehiculeClient" class="field-title mb-3">Véhicule concerné :  <span style="color: #ffa409">{{vehiculeClient.marque}}-{{vehiculeClient.model}}</span></p> <br>
        </div>
        <br>
        <div class="mt-3 row" style="background:#FAFAFA" v-if="isDesktop()">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="wizard-navigation">
                <div class="wizard-progress-with-circle">
                  <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                </div>
                <div class="progress-bar-group">
                  <div class="progress-bar-custom" id="testup"></div>
                </div>
                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                  <li class="step" id="firstStep">
                    <div class="step-title">{{ $t('sinistre.stepper_title[0]') }}</div>
                  </li>
                  <li class="step" id="secondStep">
                    <div class="step-title">{{ $t('sinistre.stepper_title[1]') }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3 row" style="background:#FAFAFA" v-if="isMobile()">
          <div class="col-md-10" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="wizard-navigation">
                <div class="wizard-progress-with-circle">
                  <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                </div>
                <div class="progress-bar-group">
                  <div class="progress-bar-custom" id="testup"></div>
                </div>
                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                  <li class="step" id="firstStep">
                    <div class="step-title">{{ $t('sinistre.stepper_title[0]') }}</div>
                  </li>
                  <li class="step" id="secondStep">
                    <div class="step-title">{{ $t('sinistre.stepper_title[1]') }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="mt-5 row" style="background:#FAFAFA" v-if="isDesktop()">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page mb-5" v-show="step === 0">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step0" aria-labelledby="step-Step0" class="wizard-tab-container">
                    <div>
                      <div class="fields">

                        <div class="field-title font-weight-bold">{{ $t('sinistre.first_stepper.stepper_title') }}&nbsp;:</div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="typeAssDesktop" class="field-label">{{ $t('sinistre.first_stepper.assurance_type_label') }}</label>
                              <select v-model="assurance" id="typeAssDesktop" name="Step8" class="field-select">
                                <option v-for="(br, index) in ListeBranche" :key="index" :value="br._id">{{br.branche}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="VehiculeAssurDesktop" class="field-label">{{ $t('sinistre.first_stepper.assurance_vehicule_label') }}</label>
                              <select @change="getPoliceNumber" v-model="vehicule" id="VehiculeAssurDesktop" name="Step8" class="field-select">
                                <option v-for="itm in listAuto" :key="item" v-bind:value="itm">{{itm}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="PoliceAssurDesktop" class="field-label">{{ $t('sinistre.first_stepper.police_number_label') }}</label>
                              <select v-model="policy" id="PoliceAssurDesktop" name="Step8" class="field-select">
                                <option v-bind:value="policy">{{ idC }}</option>
                              </select>
                            </div>
                          </div>

                        </div>
                        <div class="mt-4 row">
                          <div class="col-sm-6">
                            <div class="field-group field-default" style="margin-top:-2px">
                              <label for="dateSurvDesktop" class="field-label">
                                {{ $t('sinistre.first_stepper.date_survenance_label') }}
                                <!---->
                              </label>
                              <div class="input-group value-loan">
                                <date-picker :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1" :placeholder="$t('sinistre.first_stepper.date_survenance_placeholder')" id="dateSurvDesktop" v-model="dateSurvenance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="heureSurvenanceDesktop" class="field-label">{{ $t('sinistre.first_stepper.heure_survenance_label') }}</label>
                              <ul class="ListStyle">
                                <li>
                                  <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="20" :return-value.sync="time" lazy transition="scale-transition" offset-y full-width max-width="290px">
                                  </v-menu>

                                  <v-dialog ref="dialog" v-model="modal3" :return-value.sync="time" persistent lazy full-width width="290px">
                                    <template v-slot:activator="{ on }">
                                      <input v-model="heureSurvenance" placeholder="Heure de survenance" readonly v-on="on" id="heureSurvenanceDesktop" name="Step81" class="field-input">
                                    </template>

                                    <v-time-picker format="24hr" color="#ffa409" v-if="modal3"
                                                   v-model="heureSurvenance"
                                                   full-width class="horloge">
                                      <v-spacer></v-spacer>
                                      <v-btn flat color="#ffa409"
                                             @click="modal3 = false">Cancel
                                      </v-btn>
                                      <v-btn flat color="#ffa409"
                                             @click="$refs.dialog.save(time)">
                                        OK
                                      </v-btn>
                                    </v-time-picker>

                                  </v-dialog>

                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <button @click="ListingSinistre()" type="button" class="wizard-btn">
                      {{ $t('sinistre.first_stepper.bouton_historique_label') }}
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                    <!--<button @click="ListingSinistre()" type="button" class="wizard-btn">
                      {{ $t('sinistre.first_stepper.bouton_historique_label') }}
                    </button>-->
                    <button @click="firstStepControl()" type="button" class="ml-3 wizard-btn">
                      {{ $t('sinistre.first_stepper.bouton_suivant_label') }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="page mb-5" v-show="step === 1">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('sinistre.first_stepper.stepper_title') }}&nbsp;:</div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="pvDesktop" class="field-label">{{ $t('sinistre.first_stepper_1.pv_label') }}</label>
                              <select v-model="mandat" id="pvDesktop" name="Step8" class="field-select">
                                <option v-for="(itm, index) in select" :key="index">{{itm}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper24" class="field-label">{{ $t('sinistre.first_stepper_1.dommage_label') }}</label>
                              <div class="exp">
                                <div class="checkbox">
                                    <div>
                                      <input v-model="dommage" type="checkbox" id="materiel" name="check" value="Matériel"/>
                                      <label class="label_name" for="materiel">
                                        <span class="spanCheckbox"></span>{{ $t('sinistre.first_stepper_1.materiel_label') }}
                                      </label>

                                      <input v-model="dommage" type="checkbox" id="corporel" name="check" value="Corporel" @change="OpenDialogMsgCorporel()"/>
                                      <label class="label_name" for="corporel">
                                        <span class="spanCheckbox"></span>{{ $t('sinistre.first_stepper_1.corporel_label') }}
                                      </label>
                                    </div>
                                </div>

                              </div>
                              </div>
                          </div>
                        </div>
                        <div class="mt-4 row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper24" class="field-label">{{ $t('sinistre.first_stepper_1.pv_constat_label[0]') }} : <span class="font-weight-bold" style="color: #ffa409">{{ $t('sinistre.first_stepper_1.pv_constat_label[1]') }}</span>, {{ $t('sinistre.first_stepper_1.pv_constat_label[2]') }} : <span class="font-weight-bold" style="color: #ffa409"> {{ $t('sinistre.first_stepper_1.pv_constat_label[3]') }}</span>)</label>
                              <div class="container_forma">
                                <form class="formm">
                                  <div class="file-upload-wrapper" data-text="PV du Sinistre">
                                    <input id="pvFile" @change="filePvValidation()" name="file-upload-field" type="file" ref="SinistrePV" class="file-upload-field">
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper24" class="field-label">{{ $t('sinistre.first_stepper_1.photo_sinistre_label[0]') }} : <span class="font-weight-bold" style="color: #ffa409">{{ $t('sinistre.first_stepper_1.photo_sinistre_label[1]') }}, {{ $t('sinistre.first_stepper_1.photo_sinistre_label[2]') }}</span>, {{ $t('sinistre.first_stepper_1.photo_sinistre_label[3]') }} : <span class="font-weight-bold" style="color: #ffa409"> {{ $t('sinistre.first_stepper_1.photo_sinistre_label[4]') }}</span>)</label>
                              <div class="container_forma">
                                <form class="formm">
                                  <div class="file-upload-wrapper" data-text="Photo du Sinistre">
                                    <input id="SinitrePhoto" @change="photoSinistreValidation()" name="file-upload-field" type="file" ref="SinistrePhoto" class="file-upload-field" multiple>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3 row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper24" class="field-label">{{ $t('sinistre.first_stepper_1.circonstance_label') }}</label>
                              <textarea :placeholder="$t('sinistre.first_stepper_1.circonstance_placeholder')" v-model="Circonstance_Sinistres" maxlength='250' class='comment bg-gray-200 p-1 h-20 w-full mt-0 good' style="border-radius:10px;box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);"></textarea>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper24" class="field-label">{{ $t('sinistre.first_stepper_1.detail_dommage_label') }}</label>
                              <textarea :placeholder="$t('sinistre.first_stepper_1.detail_dommage_placeholder')"  v-model="Details_Dommages" maxlength='250' class='comment bg-gray-200 p-1 h-20 w-full mt-0 good' style="border-radius:10px;box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <button @click="returnToFistStep()" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      {{ $t('sinistre.first_stepper_1.bouton_retour_label') }}
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                    <button @click="secondStepControl()" type="button" class="wizard-btn">
                      {{ $t('sinistre.first_stepper_1.bouton_suivant_label') }}
                    </button>
                  </div>
                  <!---->
                </div>
              </div>

              <div class="page mb-5" v-show="step === 2">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step2" aria-labelledby="step-Step2" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                          <div class="field-title font-weight-bold">{{ $t('sinistre.second_stepper.stepper_title') }} :</div>
                          <div class="justify-content-center row" v-show="PartieAdverse==null">
                            <div class="col-sm-12">
                              <p class="field-title">{{ $t('sinistre.second_stepper.partie_adverse_question_label') }}</p>
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <v-radio-group row v-model="PartieAdverse" class="justify-content-center row">
                                  <v-radio :label="$t('sinistre.second_stepper.partie_adverse_title[1]')" @click="show=true,PartieAdverse='Oui'" value="Oui" class="ml-5"></v-radio>
                                  <v-radio :label="$t('sinistre.second_stepper.partie_adverse_title[2]')" @click="show=false,PartieAdverse='Non',checkAdverse()" value="Non" class="ml-5"></v-radio>
                                </v-radio-group>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-tab-content" >
                  <div role="tabpanel" id="Step2-Adverse" aria-labelledby="step-Step2-Adverse" class="wizard-tab-container">
                    <div>
                      <div class="fields" v-if="PartieAdverse">
                        <h3 class="policeLato">
                          {{$t('sinistre.second_stepper.stepper_title')}} : <span class="font-weight-bold"
                                                 style="color:#ffa409">{{PartieAdverse.toUpperCase()}}</span>
                        </h3>
                      </div>
                      <div class="fields" v-show="show==true || PartieAdverse == 'Oui'">
                        <v-form v-model="valid" ref="form">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="NomPrenomDesktop" class="field-label">{{$t('sinistre.second_stepper.nom_prenom_label')}}</label>
                              <input v-model="NomPrenom" :placeholder="$t('sinistre.second_stepper.nom_prenom_placeholder')" id="NomPrenomDesktop" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="AdressDesktop" class="field-label">{{$t('sinistre.second_stepper.adresse_label')}}</label>
                              <input v-model="adresse" :placeholder="$t('sinistre.second_stepper.adresse_placeholder')" id="AdressDesktop" name="Step8" class="field-input">
                            </div>
                          </div>
                        </div>

                        <div class="mt-3 row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="NumDesktop" class="field-label">{{$t('sinistre.second_stepper.numero_tel_label')}}</label>
                              <input @keypress="onlyNumber" v-model="phone" :placeholder="$t('sinistre.second_stepper.numero_tel_placeholder')" id="NumDesktop" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="AssureDesktop" class="field-label">{{$t('sinistre.second_stepper.assure_label')}}</label>
                              <select v-model="assureA" id="AssureDesktop" name="Step8" class="field-select">
                                <option v-for="item in listeAssure" :key="item" :value="item.value">{{item.name}}</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="mt-3 row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="policeDesktop" class="field-label">{{$t('sinistre.second_stepper.numero_police_label')}}</label>
                              <input type="text" v-model="policyAdverse" :placeholder="$t('sinistre.second_stepper.numero_police_placeholder')" id="policeDesktop" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default" style="margin-top:-2px">
                              <label for="validiteDesktop" class="field-label">
                                {{$t('sinistre.second_stepper.validite_date_label')}}
                                <!---->
                              </label>
                              <div class="input-group value-loan">
                                <date-picker :disabled-date="disabledBeforeDateSurvenance" class="field-input ml-2 mb-1 mt-1" :placeholder="$t('sinistre.second_stepper.validite_date_placeholder')" id="validiteDesktop" v-model="validite" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="mt-5 fields">
                          <h3 class="mt-3 policeLato">{{$t('sinistre.second_stepper.vehicule_implique_label')}}</h3>
                        </div>

                        <div class="mt-3 row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="marqueDesktop" class="field-label">{{$t('sinistre.second_stepper.marque_label')}}</label>
                              <input v-model="marque" :placeholder="$t('sinistre.second_stepper.marque_placeholder')" id="marqueDesktop" name="Step8" class="field-input">
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="modeleDesktop" class="field-label">{{$t('sinistre.second_stepper.model_label')}}</label>
                              <input v-model="model" :placeholder="$t('sinistre.second_stepper.model_placeholder')" id="modeleDesktop" name="Step8" class="field-input">
                            </div>
                          </div>
                        </div>

                        <div class="mt-3 row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="puissanceDesktop" class="field-label">{{$t('sinistre.second_stepper.puissance_label')}}</label>
                              <select @change="checkPuissanceFiscale(puissance)" v-model="puissance" id="puissanceDesktop" name="Step8" class="field-select">
                                <option v-for="item in PuissanceAdverse" :key="item" :value="item">{{item}}</option>
                              </select>
                              <p v-if="forceFiscaleValue > 24 ">Puissance fiscale renseignée : <span class="font-weight-bold">{{ forceFiscaleValue }}</span></p>

<!--                              <input @keypress="onlyNumber" v-model="puissance" placeholder="Puissance" id="Stepper28" name="Step8" class="field-input">-->
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="usageDesktop" class="field-label">{{$t('sinistre.second_stepper.usage_label')}}</label>
                              <select v-model="usage" id="usageDesktop" name="Step8" class="field-select">
                                <option v-for="item in listeUsageA" :key="item" :value="item.value">{{item.name}}</option>
                              </select>
                            </div>
                          </div>
                        </div>

                          <div class="mt-3 row">
                            <div class="col-sm-6">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="visiteDesktop" class="field-label">{{$t('sinistre.second_stepper.visite_technique_label')}}</label>
                                <select v-model="visite" id="visiteDesktop" name="Step8" class="field-select">
                                  <option v-for="item in visiteTech" :key="item" :value="item.value">{{item.text}}</option>
                                </select>
<!--                                <input v-model="visite" placeholder="Visite technique" id="Stepper28" name="Step8" class="field-input">-->
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="immDesktop" class="field-label">{{$t('sinistre.second_stepper.immatriculation_label')}}</label>
                                <input :maxlength="max" v-mask="mask" v-model="immatricule" :placeholder="$t('sinistre.second_stepper.immatriculation_placeholder')" id="immDesktop" name="Step8" class="field-input">
                              </div>
                            </div>
                          </div>

                          <div class="mt-5 fields">
                            <h3 class="mt-3 policeLato">{{$t('sinistre.second_stepper.passager_title')}}</h3>
                          </div>

                        <div class="mt-3">
                          <v-radio-group row v-model="passager"
                                         class="justify-content-center row">
                            <v-radio value="Oui">{{$t('sinistre.second_stepper.passager_choix_label[0]')}}</v-radio>
                            <v-radio value="Non">{{$t('sinistre.second_stepper.passager_choix_label[1]')}}</v-radio>
                          </v-radio-group>
                        </div>
                        </v-form>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <button @click="returnToSecondStep()" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      {{$t('sinistre.second_stepper.bouton_retour_label')}}
                    </button>
                  </div>
                  <div class="wizard-footer-right" v-if="this.PartieAdverse == 'Oui'">
                    <button @click="DeclarationSinistre()" type="button" class="wizard-btn">
                      {{$t('sinistre.second_stepper.bouton_valider_label')}}
                    </button>
                  </div>
                   <div class="wizard-footer-right"  v-if="this.PartieAdverse == 'Non'">
                    <button @click="DeclarationSinistre()" type="button" class="wizard-btn">
                      {{$t('sinistre.second_stepper.bouton_valider_label')}}
                    </button>
                  </div>
                  <!---->
                </div>
              </div>
            </div>
          </div>
          <!-- Modal dialog for Liste Vehicule sinistre declaration on Desktop devices&ndash -->
          <v-dialog v-model="dialogListeVehicule" persistent max-width="800px" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
              <v-card-text style="background:#FAFAFA">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="choixListeAuto" aria-hidden="true" aria-labelledby="step-choixListeAuto" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Liste de vos vehicules</div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="table-responsive">
                                <table class="table table-sm table-simple text-center">
                                  <thead class="bg-light">
                                  <tr>
                                    <th>#</th>
                                    <th>Marque & Modèle</th>
                                    <th>Actions</th>
                                  </tr>
                                  </thead>
                                  <tbody v-for="(item, index) in ListeVehicule" :key="index">
                                  <tr>
                                    <td class="border-right text-assuraf" style="border-bottom:none;">
                                                                  <span>
                                                                      <v-icon small
                                                                              class="text-assuraf">directions_car</v-icon>{{index+1}}
                                                                  </span>
                                    </td>

                                    <td class="border">{{item.marque}} {{item.model}}</td>

                                    <td class="border justify-space-around">
                                      <v-btn @click="vehiculeClient=item, dialogListeVehicule= false"
                                             flat style="text-transform:lowercase;">
                                        <v-icon small class="text-success">&#xe5ca;</v-icon>
                                        choisir
                                      </v-btn>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix">
                  <div class="wizard-footer-left">
                    <button @click="dialogListeVehicule= false" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      Fermer
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!--======================= Modal dialog for Sinistre list ==============================-->
          <v-dialog v-model="ModalListeSinistre" persistent max-width="1000" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
              <v-card-text style="background:#FAFAFA">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="listeSinistre" aria-hidden="true" aria-labelledby="step-listeSinistre" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Mes sinistres</div>
                          <div class="row">
                            <v-container class="border-radius">
                              <v-layout wrap>
                                <div class="col-sm-12">
                                  <v-data-table :headers="headers" :items="userSinistre" class="elevation-1 table table-reponsive small" style="box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);z-index: 1000;">
                                    <template slot="items" slot-scope="props">
                                      <td>{{ props.item.branche}}</td>
                                      <td>{{ props.item.contrat.numero_police}}</td>
                                      <td>{{ props.item.assureur}}</td>
                                      <td>{{DateFormater(props.item.dateSurvenance)}}</td>
                                      <td>{{DateFormater(props.item.created)}}</td>
                                      <td class="text-lg-left">
                                        <ul class="list-boutons">
                                          <li>
                                            <span class="tool_button" data-tip="Voir détails sinistre !" tabindex="1">
                                    <v-btn icon @click="setDetailsSinistre(props.item)">
                                      <v-icon color="#ffa409">&#xe8f4;</v-icon>
                                    </v-btn>
                                    </span>


                                          </li>
                                        </ul>
                                      </td>
                                    </template>
                                  </v-data-table>
                                </div>
                              </v-layout>
                            </v-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix">
                  <div class="wizard-footer-left">
                    <button @click="ModalListeSinistre=false" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      Fermer
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!--Modal dialog pour afficher information si corporel et cocher-->
          <v-dialog v-model="CorporelModal" persistent max-width="800" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
              <v-card-text style="background:#FAFAFA">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="DommCorporel" aria-hidden="true" aria-labelledby="step-DommCorporel" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold" style="color:#ffa409">Dommages Corporel</div>
                          <div class="row">
                            <v-container class="border-radius">
                              <v-layout wrap>
                                <div class="col-sm-12">
                                  <h4>En cas de dommage(s) corporel(s) le procès-verbal de constat devra <br>
                                    impérativement être établi par les services de police ou de gendarmerie.</h4>
                                </div>
                              </v-layout>
                            </v-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix">
                  <div class="wizard-footer-left">
                    <button @click="CorporelModal= false" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      Fermer
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!--======================= Modal dialog for Details Sinistre lis ==============================-->
          <v-dialog v-model="ModalDetailsSinistre" persistent max-width="1000" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
              <v-card-text style="background:#FAFAFA">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="DetailsSinistre" aria-hidden="true" aria-labelledby="step-DetailsSinistre" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Détails de Sinistre</div>
                          <div class="row">
                            <v-container class="border-radius">
                              <v-layout wrap>
                                <div class="col-sm-12">
                                  <div class=" justify-content-center row mt-3" v-if="DetailsSinistre!==null">

                                    <div class="justify-content-center row border-radius ml-3 mr-3 col-sm-12 p-2"
                                         style="border:2px solid #ffa409">
                                      <span class="ml-1 h4">Évolution à {{progress}}% </span>
                                      <v-progress-linear
                                          :value="progress"
                                          :color="color"
                                          absolute
                                          height="30">
                                      </v-progress-linear>

                                    </div>

                                    <div class="col-sm-12 p-2">

                                      <div class="col-sm-12 p-1">

                                        <div class="col-sm-6" v-if="DetailsSinistre.etat=='Résolu'">
                                                <span class="ml-1"><i class="fa fa-check-circle"
                                                                      style="font-size:23px;color:green"></i>  Résolu </span>
                                        </div>

                                        <div class="col-sm-6" v-if="DetailsSinistre.etat=='Pris en compte'">
                                                <span class="ml-1"><i class="fa fa-check-circle"
                                                                      style="font-size:23px;color:yellow"></i>  Pris en compte </span>
                                        </div>

                                        <div class="col-sm-6" v-if="DetailsSinistre.etat=='Non pris en compte'">
                                                <span class="ml-1"><i class="fa fa-ban"
                                                                      style="font-size:23px;color:orange"></i>  Non pris en compte </span>
                                        </div>

                                      </div>

                                      <div class="col-sm-12 p-1">
                                        <div class="col-sm-12" v-if="DetailsSinistre.vueAssureur">
                                        <span>
                                          <i class="fa fa-eye" style="font-size:23px;color:green"></i>
                                          {{DetailsSinistre.vueAssureur}}
                                        </span>
                                        </div>

                                        <div class="col-sm-12" v-else>
                                        <span>
                                          <i class="fa fa-eye" style="font-size:23px;color:orange"></i>
                                          Pas encore vu par l'assureur
                                        </span>
                                        </div>
                                      </div>

                                      <div class="col-sm-12">
                                        <div class="row border pt-3 pb-3" style="background:#fff;border-radius: 10px;">
                                          <div class="col-sm-4 font-weight-bold"> Date Survenance :
                                            <span class="font-weight-light">{{DateFormater(DetailsSinistre.dateSurvenance)}}</span>
                                          </div>
                                          <div class="col-sm-4 font-weight-bold"> Date de déclaration :
                                            <span class="font-weight-light">{{DateFormater(DetailsSinistre.created)}}</span>
                                          </div>
                                          <div class="col-sm-4 font-weight-bold"> Mandat :
                                            <span class="font-weight-light">{{DetailsSinistre.mandat.toUpperCase()}}</span>
                                          </div>
                                        </div>
                                        <div class="row border mt-2 pt-3 pb-3" style="background:#fff;border-radius: 10px;">
                                          <div class="col-sm-4 font-weight-bold"> Branche :
                                            <span class="font-weight-light">{{DetailsSinistre.branche.toUpperCase()}}</span>
                                          </div>
                                          <div class="col-sm-4 font-weight-bold"> Assureur :
                                            <span class="font-weight-light">{{DetailsSinistre.assureur.toUpperCase()}}</span>
                                          </div>
                                        </div>

                                        <div class="row border mt-2 pt-3 pb-3" style="background:#fff;border-radius: 10px;">
                                          <div class="col-sm-6 font-weight-bold"> Circonstances du Sinistre :
                                            <span class="font-weight-light">{{DetailsSinistre.Circonstance_Sinistres}}</span>
                                          </div>
                                          <div class="col-sm-6 font-weight-bold"> Détails des Dommages :
                                            <span class="font-weight-light">{{DetailsSinistre.Details_Dommages}}</span>
                                          </div>
                                        </div>
                                      </div>

                                    </div>

                                  </div>
                                </div>
                              </v-layout>
                            </v-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix">
                  <div class="wizard-footer-left">
                    <button @click="clsoeDetailsPopu()" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      Fermer
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!--End of Modal dialog for Details Sinistre list-->
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     ================= -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs class="mt-5 row" style="background:#FAFAFA" v-if="isMobile()">
          <div class="col-md-10" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page mb-5" v-show="step === 0">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step0-mobile" aria-labelledby="step-Step0-mobile" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('sinistre.first_stepper.stepper_title') }}&nbsp;:</div>
                        <div class="justify-content-center row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="typAssMobile" class="field-label">{{ $t('sinistre.first_stepper.assurance_type_label') }}</label>
                              <select v-model="assurance" id="typAssMobile" name="Step8" class="field-select">
                                <option v-for="(br, index) in ListeBranche" :key="index" v-bind:value="br._id">{{br.branche}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6 mt-2">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="VehiculeAssurMobile" class="field-label">{{ $t('sinistre.first_stepper.assurance_vehicule_label') }}</label>
                              <select @change="getPoliceNumber" v-model="vehicule" id="VehiculeAssurMobile" name="Step8" class="field-select">
                                <option v-for="itm in listAuto" :key="item" v-bind:value="itm">{{itm}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6 mt-2">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="policeAssurMobile" class="field-label">{{ $t('sinistre.first_stepper.police_number_label') }}</label>
                              <select v-model="idC" id="policeAssurMobile" name="Step8" class="field-select">
                                <option v-bind:value="idC">{{ policy }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6 mt-2">
                            <div class="field-group field-default mb-4 mb-sm-0" style="margin-top:-2px">
                              <label for="dateSurMobile" class="field-label">
                                {{ $t('sinistre.first_stepper.date_survenance_label') }}
                                <!---->
                              </label>
                              <div class="input-group value-loan">
                                <date-picker :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1" :placeholder="$t('sinistre.first_stepper.date_survenance_placeholder')" id="dateSurMobile" v-model="dateSurvenance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6 mt-2">
                            <div class="field-group field-default mb-4 mb-sm-0" style="margin-top:-2px">
                              <label for="heureSurvenanceMobile" class="field-label">
                                {{ $t('sinistre.first_stepper.heure_survenance_label') }}
                                <!---->
                              </label>
                              <ul class="ListStyle">
                                <li>
                                  <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="20" :return-value.sync="time" lazy transition="scale-transition" offset-y full-width max-width="290px">
                                  </v-menu>

                                  <v-dialog ref="dialog" v-model="modal3" :return-value.sync="time" persistent lazy full-width width="290px">
                                    <template v-slot:activator="{ on }">
                                      <input v-model="heureSurvenance" placeholder="Heure de survenance" readonly v-on="on" id="heureSurvenanceMobile" name="Step8" class="field-input">
                                    </template>

                                    <v-time-picker format="24hr" color="#ffa409" v-if="modal3"
                                                   v-model="heureSurvenance"
                                                   full-width class="horloge">
                                      <v-spacer></v-spacer>
                                      <v-btn flat color="#ffa409"
                                             @click="modal3 = false">Cancel
                                      </v-btn>
                                      <v-btn flat color="#ffa409"
                                             @click="$refs.dialog.save(time)">
                                        OK
                                      </v-btn>
                                    </v-time-picker>

                                  </v-dialog>

                                </li>
                              </ul>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                  </div>
                  <div class="wizard-footer-right">
                    <button @click="ListingSinistre()" type="button" class="wizard-btn">
                      {{ $t('sinistre.first_stepper.bouton_historique_label') }}
                    </button>
                    <button @click="firstStepControl()" type="button" class="ml-3 wizard-btn">
                      {{ $t('sinistre.first_stepper.bouton_suivant_label') }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="page mb-5" v-show="step === 1">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1-mobile" aria-labelledby="step-Step1-mobile" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('sinistre.first_stepper.stepper_title') }}&nbsp;:</div>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="pvMobile" class="field-label">{{ $t('sinistre.first_stepper_1.pv_label') }}</label>
                              <select v-model="mandat" id="pvMobile" name="Step8" class="field-select">
                                <option v-for="(itm, index) in select" :key="index">{{itm}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-sm-6 mt-2">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper24" class="field-label">{{ $t('sinistre.first_stepper_1.dommage_label') }}</label>
                              <div class="exp" style="margin-top:-5px">
                                <div class="checkbox">
                                  <div>
                                    <input v-model="dommage" type="checkbox" id="materiel-mobile" name="check" value="Matériel"/>
                                    <label class="label_name" for="materiel-mobile">
                                      <span class="spanCheckbox"></span>{{ $t('sinistre.first_stepper_1.materiel_label') }}
                                    </label>

                                    <input v-model="dommage" type="checkbox" id="corporel-mobile" name="check" value="Corporel" @change="OpenDialogMsgCorporel()"/>
                                    <label class="label_name" for="corporel-mobile">
                                      <span class="spanCheckbox"></span>{{ $t('sinistre.first_stepper_1.corporel_label') }}
                                    </label>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6 mt-2">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper24" class="field-label">{{ $t('sinistre.first_stepper_1.pv_constat_label[0]') }} : <span class="font-weight-bold" style="color: #ffa409">{{ $t('sinistre.first_stepper_1.pv_constat_label[1]') }}</span>, {{ $t('sinistre.first_stepper_1.pv_constat_label[2]') }} : <span class="font-weight-bold" style="color: #ffa409">{{ $t('sinistre.first_stepper_1.pv_constat_label[3]') }}</span>)</label>
                              <div class="container_forma">
                                <form class="formm">
                                  <div class="file-upload-wrapper" data-text="PV du Sinistre">
                                    <input id="pvFileMobile" @change="filePvValidationMobile()" name="file-upload-field" type="file" ref="SinistrePV" class="file-upload-field">
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6 mt-2">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper24" class="field-label">{{ $t('sinistre.first_stepper_1.photo_sinistre_label[0]') }} : <span class="font-weight-bold" style="color: #ffa409">{{ $t('sinistre.first_stepper_1.photo_sinistre_label[1]') }}, {{ $t('sinistre.first_stepper_1.photo_sinistre_label[2]') }}</span>, {{ $t('sinistre.first_stepper_1.photo_sinistre_label[3]') }} : <span class="font-weight-bold" style="color: #ffa409">{{ $t('sinistre.first_stepper_1.photo_sinistre_label[4]') }}</span>)</label>
                              <div class="container_forma">
                                <form class="formm">
                                  <div class="file-upload-wrapper" data-text="Photo du Sinistre">
                                    <input id="SinitrePhotoMobile" @change="photoSinistreValidationMobile()" name="file-upload-field" type="file" ref="SinistrePhoto" class="file-upload-field" multiple>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-6 mt-2">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper24" class="field-label">{{ $t('sinistre.first_stepper_1.circonstance_label') }}</label>
                              <textarea :placeholder="$t('sinistre.first_stepper_1.circonstance_placeholder')" v-model="Circonstance_Sinistres" maxlength='250' class='comment bg-gray-200 p-1 h-20 w-full mt-0 good' style="border-radius:10px;box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);"></textarea>
                            </div>
                          </div>
                          <div class="col-sm-6 mt-2">
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <label for="Stepper24" class="field-label">{{ $t('sinistre.first_stepper_1.detail_dommage_label') }}</label>
                              <textarea :placeholder="$t('sinistre.first_stepper_1.detail_dommage_placeholder')"  v-model="Details_Dommages" maxlength='250' class='comment bg-gray-200 p-1 h-20 w-full mt-0 good' style="border-radius:10px;box-shadow: 9px 12px 18px rgb(0 0 0 / 10%);"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <button @click="returnToFistStep()" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      {{ $t('sinistre.first_stepper_1.bouton_retour_label') }}
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                    <button @click="secondStepControl()" type="button" class="wizard-btn">
                      {{ $t('sinistre.first_stepper_1.bouton_suivant_label') }}
                    </button>
                  </div>
                  <!---->
                </div>
              </div>

              <div class="page mb-5" v-show="step === 2">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step2-mobile" aria-labelledby="step-Step2-mobile" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <div class="field-title font-weight-bold">{{ $t('sinistre.second_stepper.stepper_title') }}:</div>
                        <div class="row" v-show="PartieAdverse==null">
                          <div class="col-sm-6">
                            <p class="field-title mb-3">{{ $t('sinistre.second_stepper.partie_adverse_question_label') }}</p> <br>
                            <div class="field-group field-default mb-4 mb-sm-0">
                              <v-radio-group row v-model="PartieAdverse" class="justify-content-center row">
                                <v-radio :label="$t('sinistre.second_stepper.partie_adverse_title[1]')" @click="show=true,PartieAdverse='Oui'" value="Oui" class="ml-5"></v-radio>
                                <v-radio :label="$t('sinistre.second_stepper.partie_adverse_title[2]')" @click="show=false,PartieAdverse='Non',checkAdverse()" value="Non" class="ml-5"></v-radio>
                              </v-radio-group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-tab-content" >
                  <div role="tabpanel" id="Step1-Adverse-mobile" aria-labelledby="step-Step1-Adverse-mobile" class="wizard-tab-container">
                    <div>
                      <div class="fields" v-if="PartieAdverse">
                        <h3 class="policeLato">
                          {{$t('sinistre.second_stepper.stepper_title')}} : <span class="font-weight-bold"
                                                 style="color:#ffa409">{{PartieAdverse.toUpperCase()}}</span>
                        </h3>
                      </div>
                      <div class="fields" v-show="show==true || PartieAdverse == 'Oui'">
                        <v-form v-model="valid" ref="form">
                          <div class="row">
                            <div class="col-sm-6">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="nomPrenomMobile" class="field-label">{{$t('sinistre.second_stepper.nom_prenom_label')}}</label>
                                <input v-model="NomPrenom" :placeholder="$t('sinistre.second_stepper.nom_prenom_placeholder')" id="nomPrenomMobile" name="Step8" class="field-input">
                              </div>
                            </div>
                            <div class="col-sm-6 mt-2">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="adressMobile" class="field-label">{{$t('sinistre.second_stepper.adresse_label')}}</label>
                                <input v-model="adresse" :placeholder="$t('sinistre.second_stepper.adresse_placeholder')" id="adressMobile" name="Step8" class="field-input">
                              </div>
                            </div>
                            <div class="col-sm-6 mt-2">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="telMobile" class="field-label">{{$t('sinistre.second_stepper.numero_tel_label')}}</label>
                                <input type="number" @keypress="onlyNumber" v-model="phone" :placeholder="$t('sinistre.second_stepper.numero_tel_placeholder')" id="telMobile" name="Step8" class="field-input">
                              </div>
                            </div>
                            <div class="col-sm-6 mt-2">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="assureMobile" class="field-label">{{$t('sinistre.second_stepper.assure_label')}}</label>
                                <select v-model="assureA" id="assureMobile" name="Step8" class="field-select">
                                  <option v-for="item in listeAssure" :key="item" :value="item.value">{{item.name}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-6 mt-2">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="policeAdverseMobile" class="field-label">{{$t('sinistre.second_stepper.numero_police_label')}}</label>
                                <input type="text" v-model="policyAdverse" :placeholder="$t('sinistre.second_stepper.numero_police_placeholder')" id="policeAdverseMobile" name="Step8" class="field-input">
                              </div>
                            </div>
                            <div class="col-sm-6 mt-2">
                              <div class="field-group field-default" style="margin-top:-2px">
                                <label for="Stepper25" class="field-label">
                                  {{$t('sinistre.second_stepper.validite_date_label')}}
                                  <!---->
                                </label>
                                <div class="input-group value-loan">
                                  <date-picker :disabled-date="disabledBeforeDateSurvenance" class="field-input ml-2 mb-1 mt-1" :placeholder="$t('sinistre.second_stepper.validite_date_placeholder')" id="Stepper25" v-model="validite" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="mt-5 fields">
                            <h3 class="mt-3 policeLato">{{$t('sinistre.second_stepper.vehicule_implique_label')}}</h3>
                          </div>

                          <div class="mt-3 row">
                            <div class="col-sm-6">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="marqueMobile" class="field-label">{{$t('sinistre.second_stepper.marque_label')}}</label>
                                <input v-model="marque" :placeholder="$t('sinistre.second_stepper.marque_placeholder')" id="marqueMobile" name="Step8" class="field-input">
                              </div>
                            </div>
                            <div class="col-sm-6 mt-2">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="modeleMobile" class="field-label">{{$t('sinistre.second_stepper.model_label')}}</label>
                                <input v-model="model" :placeholder="$t('sinistre.second_stepper.model_placeholder')" id="modeleMobile" name="Step8" class="field-input">
                              </div>
                            </div>
                            <div class="col-sm-6 mt-2">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="puissanceMobile" class="field-label">{{$t('sinistre.second_stepper.puissance_label')}}</label>
                                <select @change="checkPuissanceFiscale(puissance)"  v-model="puissance" id="puissanceMobile" name="Step8" class="field-select">
                                  <option v-for="item in PuissanceAdverse" :key="item" :value="item">{{item}}</option>
                                </select>
                                <p v-if="forceFiscaleValue > 24 ">Puissance fiscale renseignée : <span class="font-weight-bold">{{ forceFiscaleValue }}</span></p>
                              </div>
                            </div>
                            <div class="col-sm-6 mt-2">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="usageMobile" class="field-label">{{$t('sinistre.second_stepper.usage_label')}}</label>
                                <select v-model="usage" id="usageMobile" name="Step8" class="field-select">
                                  <option v-for="item in listeUsageA" :key="item" :value="item.value">{{item.name}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-6 mt-2">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="visiteTechMobile" class="field-label">{{$t('sinistre.second_stepper.visite_technique_label')}}</label>
                                <select v-model="visite" id="visiteTechMobile" name="Step8" class="field-select">
                                  <option v-for="item in visiteTech" :key="item" :value="item.value">{{item.text}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-6 mt-2">
                              <div class="field-group field-default mb-4 mb-sm-0">
                                <label for="immMobile" class="field-label">{{$t('sinistre.second_stepper.immatriculation_label')}}</label>
                                <input @input="validateImmatriculation" maxlength="10" v-model="immatricule" :placeholder="$t('sinistre.second_stepper.immatriculation_placeholder')" id="immMobile" name="Step8" class="field-input">
                              </div>
                            </div>
                          </div>

                          <div class="mt-5 fields">
                            <h3 class="mt-3 policeLato">{{$t('sinistre.second_stepper.passager_title')}}</h3>
                          </div>

                          <div class="mt-3">
                            <v-radio-group row v-model="passager" class="justify-content-center row">
                              <v-radio value="Oui">{{$t('sinistre.second_stepper.passager_choix_label[0]')}}</v-radio>
                              <v-radio value="Non">{{$t('sinistre.second_stepper.passager_choix_label[1]')}}</v-radio>
                            </v-radio-group>
                          </div>
                        </v-form>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix mb-5">
                  <div class="wizard-footer-left">
                    <button @click="returnToSecondStep()" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      {{$t('sinistre.second_stepper.bouton_retour_label')}}
                    </button>
                  </div>
                  <div class="wizard-footer-right" v-if="this.PartieAdverse == 'Oui'">
                    <button @click="DeclarationSinistre()" type="button" class="wizard-btn">
                      {{$t('sinistre.second_stepper.bouton_valider_label')}}
                    </button>
                  </div>
                   <div class="wizard-footer-right" v-if="this.PartieAdverse == 'Non'">
                    <button @click="DeclarationSinistre()" type="button" class="wizard-btn">
                      {{$t('sinistre.second_stepper.bouton_valider_label')}}
                    </button>
                  </div>
                  <!---->
                </div>
              </div>
            </div>
          </div>
          <!-- Modal dialog for Liste Vehicule sinistre declaration on Mobile devices -->
          <v-dialog v-model="dialogListeVehicule" persistent v-if="isMobile()" max-width="1200">
            <v-card elevation="24" class="border-radius">
              <v-card-text style="background:#FAFAFA">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="choixListeAutoMobile" aria-hidden="true" aria-labelledby="step-choixListeAutoMobile" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Liste de vos vehicules</div>
                          <div class="row">
                            <div class="col-sm-12">
                              <div class="table-responsive">
                                <table class="table table-sm table-simple text-center">
                                  <thead class="bg-light">
                                  <tr>
                                    <th>#</th>
                                    <th>Marque & Modèle</th>
                                    <th>Actions</th>
                                  </tr>
                                  </thead>
                                  <tbody v-for="(item, index) in ListeVehicule" :key="item">
                                  <tr>
                                    <td class="border-right text-assuraf" style="border-bottom:none;">
                                                        <span>
                                                            <v-icon small class="text-assuraf">&#xe531;</v-icon>{{index+1}}
                                                        </span>
                                    </td>

                                    <td class="border">{{item.marque}} {{item.model}}</td>

                                    <td class="border justify-space-around">
                                      <v-btn @click="vehiculeClient=item, dialogListeVehicule= false" flat
                                             style="text-transform:lowercase;">
                                        <v-icon small class="text-success">&#xe5ca;</v-icon>
                                        choisir
                                      </v-btn>
                                    </td>
                                  </tr>

                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix">
                  <div class="wizard-footer-left">
                    <button @click="dialogListeVehicule= false" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      Fermer
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!--======================= Modal dialog for Sinistre list ==============================-->
          <v-dialog v-model="ModalListeSinistre" persistent max-width="800" v-if="isMobile()">
            <v-card elevation="24" class="border-radius">
              <v-card-text style="background:#FAFAFA">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="listeSinistreMobile" aria-hidden="true" aria-labelledby="step-listeSinistreMobile" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Mes sinistres</div>
                          <div class="row">
                            <v-container class="border-radius">
                              <v-layout wrap>
                                <div class="col-sm-12">
                                  <v-data-table :headers="headerMobil" :items="userSinistre" class=" mt-3 table table-reponsive small" style="z-index: 10000">
                                    <template slot="items" slot-scope="props">
                                      <td>
                                        <a href="javascript: void(0)" @click="setDetailsSinistre(props.item)">
                                          {{DateFormater(props.item.created)}}
                                        </a>
                                      </td>
                                      <td @click="setDetailsSinistre(props.item)">
                                        <a href="javascript: void(0)" @click="setDetailsSinistre(props.item)">
                                          {{ props.item.branche}}
                                        </a>
                                      </td>
                                    </template>
                                  </v-data-table>
                                </div>
                              </v-layout>
                            </v-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix">
                  <div class="wizard-footer-left">
                    <button @click="ModalListeSinistre=false" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      Fermer
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!--Modal dialog pour afficher information si corporel et cocher-->
          <v-dialog v-model="CorporelModal" persistent max-width="800" v-if="isMobile()">
            <v-card elevation="24" class="border-radius">
              <v-card-text style="background:#FAFAFA">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="DommCorporelMobile" aria-hidden="true" aria-labelledby="step-DommCorporelMobile" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold" style="color: #ffa409">Dommages Corporel</div>
                          <div class="row">
                            <v-container class="border-radius">
                              <v-layout wrap>
                                <div class="col-sm-12">
                                  <h4>En cas de dommage(s) corporel(s) le procès-verbal de constat devra <br>
                                    impérativement être établi par les services de police ou de gendarmerie.</h4>
                                </div>
                              </v-layout>
                            </v-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix">
                  <div class="wizard-footer-left">
                    <button @click="CorporelModal= false" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      Fermer
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!--======================= Modal dialog for Details Sinistre lis ==============================-->
          <v-dialog v-model="ModalDetailsSinistre" persistent max-width="1000" v-if="isMobile()">
            <v-card elevation="24" class="border-radius">
              <v-card-text style="background:#FAFAFA">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="DetailsSinistreMobile" aria-hidden="true" aria-labelledby="step-DetailsSinistreMobile" class="wizard-tab-container">
                    <div>
                      <div class="loan-group loan-group-0">
                        <div class="fields">
                          <div class="field-title font-weight-bold">Détails de Sinistre</div>
                          <div class="row">
                            <v-container class="border-radius">
                              <v-layout wrap>
                                <div class="col-sm-12">
                                  <div class="row" v-if="DetailsSinistre!==null">

                                    <div class="col-sm-12" style="border:1px solid grey;border-radius:18px;">
                                      <span class="ml-2 h2"> {{progress}}% </span>
                                      <v-progress-linear
                                          :value="progress"
                                          :color="color"
                                          absolute
                                          height="30">
                                      </v-progress-linear>
                                    </div>

                                    <div class="col-sm-12 p-2">

                                      <div class="col-sm-12 p-1">

                                        <div class="col-sm-6" v-if="DetailsSinistre.etat=='Résolu'">
                                                    <span class="ml-1"><i class="fa fa-check-circle"
                                                                          style="font-size:23px;color:green"></i>  Résolu </span>
                                        </div>

                                        <div class="col-sm-6" v-if="DetailsSinistre.etat=='Pris en compte'">
                                                    <span class="ml-1"><i class="fa fa-check-circle"
                                                                          style="font-size:23px;color:yellow"></i>  Pris en compte </span>
                                        </div>

                                        <div class="col-sm-6" v-if="DetailsSinistre.etat=='Non pris en compte'">
                                                    <span class="ml-1"><i class="fa fa-ban"
                                                                          style="font-size:23px;color:orange"></i>  Non pris en compte </span>
                                        </div>

                                      </div>

                                      <div class="col-sm-12 p-1">
                                        <div class="col-sm-12" v-if="DetailsSinistre.vueAssureur">
                                                <span>
                                                  <i class="fa fa-eye" style="font-size:23px;color:green"></i>
                                                  {{DetailsSinistre.vueAssureur}}
                                                </span>
                                        </div>

                                        <div class="col-sm-12" v-else>
                                                <span>
                                                  <i class="fa fa-eye" style="font-size:23px;color:orange"></i>
                                                  Pas encore vu par l'assureur
                                                </span>
                                        </div>
                                      </div>

                                      <div class="col-sm-12">
                                        <div class="col-sm-12" style="margin-top:20px;" id="info">
                                          <div class="col border p-2 pl-2" style="background:#fff;border-radius: 10px;">
                                            <span class="font-weight-black">Date Survenance : </span>
                                            <span> {{DateFormater(DetailsSinistre.dateSurvenance)}}</span>
                                          </div>
                                          <div class="col border mt-2 p-2 pl-2" style="background:#fff;border-radius: 10px;">
                                            <span class="font-weight-black">Date de déclaration : </span>
                                            <span> {{DateFormater(DetailsSinistre.created)}}</span>
                                          </div>
                                          <div class="col border mt-2 p-2 pl-2" style="background:#fff;border-radius: 10px;">
                                            <span class="font-weight-black">Mandat : </span>
                                            <span> {{DetailsSinistre.mandat.toUpperCase()}}</span>
                                          </div>
                                          <div class="col border mt-2 p-2 pl-2" style="background:#fff;border-radius: 10px;">
                                            <span class="font-weight-black">Branche : </span>
                                            <span> {{DetailsSinistre.branche.toUpperCase()}}</span>
                                          </div>
                                          <div class="col border mt-2 p-2 pl-2" style="background:#fff;border-radius: 10px;">
                                            <span class="font-weight-black">Assureur : </span>
                                            <span> {{DetailsSinistre.assureur.toUpperCase()}}</span>
                                          </div>
                                          <div class="col border mt-2 p-2 pl-2" style="background:#fff;border-radius: 10px;">
                                            <span class="font-weight-black">Circonstances du Sinistre : </span>
                                            <span> {{DetailsSinistre.Circonstance_Sinistres}}</span>
                                          </div>
                                          <div class="col border mt-2 p-2 pl-2" style="background:#fff;border-radius: 10px;">
                                            <span class="font-weight-black">Détails des Dommages : </span>
                                            <span> {{DetailsSinistre.Details_Dommages}}</span>
                                          </div>
                                        </div>
                                      </div>

                                    </div>

                                  </div>
                                </div>
                              </v-layout>
                            </v-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wizard-card-footer clearfix">
                  <div class="wizard-footer-left">
                    <button @click="clsoeDetailsPopu()" type="button" class="wizard-btn">
                      <span class="fas fa-arrow-left"></span>
                      Fermer
                    </button>
                  </div>
                  <div class="wizard-footer-right">
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!--End of Modal dialog for Details Sinistre list-->
        </div>

        <!-- ========= DIALOG PUISSANCE FISCALE SUPPERIEUR A 24 ============ -->
      <!-- ========= DIALOG PUISSANCE FISCALE SUPPERIEUR A 24 ============ -->
      <v-dialog v-model="forceFiscaleModal" persistent max-width="600px">
        <v-card elevation="24" class="border-radius">
          <v-card-text style="background:#FAFAFA">
            <div class="wizard-tab-content">
              <div role="tabpanel" id="valeurNeuf" aria-hidden="true" aria-labelledby="step-valeurNeuf"
                class="wizard-tab-container">
                <div>
                  <div class="loan-group loan-group-0">
                    <div class="fields">
                      <div class="field-title font-weight-bold">Puissance fiscale&nbsp;:</div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="field-group field-default">
                            <label for="force_fiscale" class="field-label">
                              Puissance fiscale (nombre de chevaux)
                              <!---->
                            </label>
                            <div class="input-group value-loan">
                              <input @keypress="onlyNumber" v-model="forceFiscaleValue" placeholder="renseignez une puissance supperieure à 24"
                                id="force_fiscale" name="forceFiscale" class="field-input">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-card-footer clearfix">
              <div class="wizard-footer-left">
                <button @click="closeForceFiscaleModal()" type="button" class="wizard-btn">
                  <span class="fas fa-arrow-left"></span>
                  {{ $t('devis.devis_auto.bouton_retour') }}
                </button>
              </div>
              <div class="wizard-footer-right">
                <button @click="checkForceFiscale()" type="button" class="wizard-btn">
                  {{ $t('devis.devis_auto.bouton_valider') }}
                </button>
              </div>
              <!---->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      </div>
    </div>
  </div>

</template>

<script>
import Api from "./../../services/Api";
import store from "./../../store/store";
import dayjs from 'dayjs'
import listeAssureA from '../../common/AssureAdverse.json'
import listeUsageA from '../../common/UsageAdverse.json'
import MarqueVehicule from '../../common/marqueauto.json'

import $ from "jquery";
import {
  mask
} from 'vue-the-mask'

export default {
  directives: {
    mask,
  },
  data() {
    return {
      vehicule : null,
      idC : null,
      listAuto : [],
      listNumPolice : [],
      listAtoAll : [],
      listeMarque : MarqueVehicule,
      visiteTech: [
        {text: "Oui", value: "OUI"},
        {text: "Non", value: "NON"}
      ],
      PuissanceAdverse: ['2', '3', '4', '5', '6', '7', '8', '9', '10', 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, '24+'],
      listeAssure: listeAssureA.Assure,
      listeUsageA : listeUsageA.Usage,
      hourFormat : 'HH:mm',
      mask: 'XX-XXXX-XX',
      filePhoto : null,
      step : 0,
      CorporelModal: false,
      next : true,
      NextStep : false,
      showFormSinistre: false,
      showEtapes: true,
      s1: 0,
      valid: false,
      brancheCheck: null,
      show: false,
      row: null,
      userContrat: [],
      userSinistre: [],
      e1: 0,
      LoadDocumentList: false,
      ModalDetailsSinistre: false,
      DetailsSinistre: null,
      ListeVehicule: [],
      RecapitulatifSinistre: [],
      dialogListeVehicule: false,
      Circonstance_Sinistres: null,
      Details_Dommages: null,
      adresse: null,
      NomPrenom: null,
      heureSurvenance: '00:00',
      dateSurvenance: null,
      vehiculeClient: null,
      usage: null,
      selectedDoc: null,
      displayDoc: null,
      headerMesDoc: [
        {text: "Type de document", value: "type_document", sortable: false},
        {text: "Fichier", value: "lien_document", sortable: false},
        {text: "Date d'ajout", value: "date_upload", sortable: false},
        {text: "Action", value: "action"}
      ],
      headerMesDocMobile: [
        {text: "Date d'ajout", value: "date_upload", sortable: false},
        {text: "Fichier", value: "lien_document", sortable: false},

      ],
      visite: null,
      PartieAdverse: null, //'Non',
      ToastTabSucess: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 10000,
        fitToScreen: true,
        type: 'success',
        className: 'custom-success-class'
      }, // Customized options for success toast
      ToastTabError: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 10000,
        fitToScreen: true,
        type: 'error'
      },// Customized options for error toast
      model: null,
      passager: null,
      profession: null,
      policy: null,
      policyAdverse: null,
      validite: null,
      immatricule: null,
      marque: null,
      puissance: null,
      dommage: [],
      assureA: null,
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v && v.length <= 10 || 'Name must be less than 10 characters'
      ],
      assurRules: [
        (v) => !!v || "Nom de l'assurance est  obligatoire",
      ],
      immaRules: [
        (v) => !!v || "le numero d'immatriculation  est  obligatoire",
      ],
      profRules: [
        (v) => !!v || 'profession est  obligatoire',
      ],
      policyRules: [
        (v) => !!v || 'N°Police est  obligatoire',
      ],

      constatRules: [
        (v) => !!v || 'Pv de constat obligatoire',
      ],

      checkbox: true,
      checkbox2: false,
      email: '',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],

      dateRules: [
        (v) => !!v || 'champ obligatoire',

      ],

      date: new Date().toISOString().substr(0, 10),
      date_declaration_client : new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      menuDate: false,
      time: null,
      userDocument: [],
      menu3: false,
      ModalListeSinistre: false,
      modal3: false,
      assurance: null,
      mandat: null,
      headers: [
        {text: "Branche", sortable: false, value: "branche"},
        {text: "Police d'assurance", sortable: false, value: "contrat.numero_police"},
        {text: "Assureur", sortable: false, value: "assureur"},
        {text: "Date Survenance", sortable: false, value: "dateSurvenance"},
        {text: "Date de déclaration", sortable: false, value: "created"},
        {text: "Actions", sortable: false, value: "action"}
      ],
      headerMobil: [
        {text: "Date", sortable: false, value: "created"},
        {text: "Branche", sortable: false, value: "branche"},
      ],

      headersVehicules: [
        {text: "Marque", sortable: false, value: "marque"},
        {text: "Modèle", sortable: false, value: "model"},
      ],
      select: [
        'Police',
        'Gendarmerie',
        'Huissier',
        'Taxawulen',
        'Autres'
      ],
      police: null,
      valueProgressBar: 0,
      ListeBranche: null,
      forceFiscaleModal : false,
      forceFiscaleValue : null
    }
  },

  computed: {
    progress() {
      return Math.min(100, this.valueProgressBar)
    },
    color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
    },
  },

  watch: {
    assurance(val) {
      this.userContrat = [];
      if (val != null && val !== '') {

        this.checkBranch(val);
        this.GetUserContarts(val)
      }
    },

    policy(val) {
      if (this.brancheCheck == 'Automobile') {
        this.getListVehiculeByIdContrat(val)
      }
    }
  },
  methods: {
    validateImmatriculation() {
      const regex = /^[A-Za-z0-9]{2}-[A-Za-z0-9]{4}-[A-Za-z0-9]{2}$/;
      if (!regex.test(this.immatricule)) {
        this.immatricule = this.immatriculation.replace(/[^A-Za-z0-9-]/g, '');
      }
    },
    checkPuissanceFiscale(item){
        if(item == '24+'){
          this.forceFiscaleModal = true
        }else {
           this.forceFiscaleValue = null
        }
      },

      closeForceFiscaleModal(){
        this.forceFiscaleValue = null
        this.forceFiscaleModal = false
        this.puissance = null
      },

      checkForceFiscale(){
        if(this.forceFiscaleValue == ''){
          this.$toasted.show('Veuillez renseigner une puissance fiscale ! ', this.ToastTabError)
        } else if(this.forceFiscaleValue < 25){
          this.$toasted.show('Veuillez renseigner une puissance fiscale superieure à 24 ! ', this.ToastTabError)
        } else {
          this.forceFiscaleModal = false
        }
      },

    getPoliceNumber(){
      let numPolic = this.vehicule
      for(let NP of this.listNumPolice){
        if(numPolic==NP.vehicule){
            numPolic = NP
           this.policy = numPolic.id
           this.idC = numPolic.numero_police
  
        }
      }
     
      return numPolic
    },



    checkAdverse(){
       if (this.PartieAdverse == 'Non'){
        this.DeclarationSinistre()
      }
    },
    /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
    onlyNumber($event) {
      let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
      if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
        $event.preventDefault();
      }
    },

    disabledBeforeToday(date) {
      const today = new Date();
      return date > today;
    },
    disabledBeforeDateSurvenance (date){
      const today = new Date(this.dateSurvenance)
      return date <= today
    },

    disabledAfterToday(date) {
      const today = dayjs(new Date()).add(-1, 'day')
      return date < today;
    },

    filePvValidation() {
      $("form").on("change", ".file-upload-field", function(){
        $(this).parent(".file-upload-wrapper").attr("data-text",
            $(this).val().replace(/.*(\/|\\)/, '') );
      });

      let fileInput = document.getElementById('pvFile');
      let filePath = fileInput.value;
      // Controle du format du fichier
      let allowedExtensions = /(\.pdf)$/i;
      if (!allowedExtensions.exec(filePath)) {
        this.$toasted.show("le format du fichier n'est pas accepté ! ",this.ToastTabError);
        fileInput.value = '';
        return false;
      } else {
        // Verfier si le fichier est selectioné.
        if (fileInput.files.length > 0) {
          for (let i = 0; i <= fileInput.files.length - 1; i++) {
            const fsize = fileInput.files.item(i).size;
            const file = Math.round((fsize / 1024));
            // Controle de la taille du fichier.
            if (file >= 5096) {
              this.$toasted.show("Fichier trop volumineux, veuillez sélectionner un fichier de moins de 5 Mo ! ",this.ToastTabError)
              fileInput.value = '';
            } else {
              this.$toasted.show("Fichier ajouté avec succés ! ",this.ToastTabSucess)
            }
          }
        }
      }
    },

    photoSinistreValidation() {
      $("form").on("change", ".file-upload-field", function(){
        $(this).parent(".file-upload-wrapper").attr("data-text",
            $(this).val().replace(/.*(\/|\\)/, '') );
      });

      let fileInput = document.getElementById('SinitrePhoto');
      let filePath = fileInput.value;

      // Controle du format du fichier
      let allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
      if (!allowedExtensions.exec(filePath)) {
        this.$toasted.show("le format du fichier n'est pas accepté ! ",this.ToastTabError);
        fileInput.value = '';
        return false;
      } else {
        // Verfier si le fichier est selectioné.
        if (fileInput.files.length > 0) {
          for (let i = 0; i <= fileInput.files.length - 1; i++) {
            const fsize = fileInput.files.item(i).size;
            const file = Math.round((fsize / 1024));
            // Controle de la taille du fichier.
            if (file >= 5096) {
              this.$toasted.show("Fichier trop volumineux, veuillez sélectionner un fichier de moins de 5 Mo ! ",this.ToastTabError)
              fileInput.value = '';
            } else {
              this.$toasted.show("Fichier ajouté avec succés ! ",this.ToastTabSucess)
            }
          }
        }
      }
    },

    filePvValidationMobile() {
      $("form").on("change", ".file-upload-field", function(){
        $(this).parent(".file-upload-wrapper").attr("data-text",
            $(this).val().replace(/.*(\/|\\)/, '') );
      });

      let fileInput = document.getElementById('pvFileMobile');
      let filePath = fileInput.value;

      // Controle du format du fichier
      let allowedExtensions = /(\.pdf)$/i;
      if (!allowedExtensions.exec(filePath)) {
        this.$toasted.show("le format du fichier n'est pas accepté ! ",this.ToastTabError);
        fileInput.value = '';
        return false;
      } else {
        // Verfier si le fichier est selectioné.
        if (fileInput.files.length > 0) {
          for (let i = 0; i <= fileInput.files.length - 1; i++) {
            const fsize = fileInput.files.item(i).size;
            const file = Math.round((fsize / 1024));
            // Controle de la taille du fichier.
            if (file >= 5096) {
              this.$toasted.show("Fichier trop volumineux, veuillez sélectionner un fichier de moins de 5 Mo ! ",this.ToastTabError)
              fileInput.value = '';
            } else {
              this.$toasted.show("Fichier ajouté avec succés ! ",this.ToastTabSucess)
            }
          }
        }
      }
    },

    photoSinistreValidationMobile() {
      $("form").on("change", ".file-upload-field", function(){
        $(this).parent(".file-upload-wrapper").attr("data-text",
            $(this).val().replace(/.*(\/|\\)/, '') );
      });

      let fileInput = document.getElementById('SinitrePhotoMobile');
      let filePath = fileInput.value;

      // Controle du format du fichier
      let allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
      if (!allowedExtensions.exec(filePath)) {
        this.$toasted.show("le format du fichier n'est pas accepté ! ",this.ToastTabError);
        fileInput.value = '';
        return false;
      } else {
        // Verfier si le fichier est selectioné.
        if (fileInput.files.length > 0) {
          for (let i = 0; i <= fileInput.files.length - 1; i++) {
            const fsize = fileInput.files.item(i).size;
            const file = Math.round((fsize / 1024));
            // Controle de la taille du fichier.
            if (file >= 5096) {
              this.$toasted.show("Fichier trop volumineux, veuillez sélectionner un fichier de moins de 5 Mo ! ",this.ToastTabError)
              fileInput.value = '';
            } else {
              this.$toasted.show("Fichier ajouté avec succés ! ",this.ToastTabSucess)
            }
          }
        }
      }
    },

    OpenDialogMsgCorporel: function () {
      let trouver = 0;
      for (let index = 0; index < this.dommage.length; index++) {
        if (this.dommage[index] == 'Corporel') {
          trouver = 1
        }
      }

      if (trouver == 1 ) {
        this.CorporelModal = true
      } else {
        this.CorporelModal = false
      }
    },

    ValideFirstStepControl(){
      if(this.dateSurvenance && this.heureSurvenance && this.mandat
          && this.dommage && this.Circonstance_Sinistres && this.Details_Dommages){
        this.e1 = 2
      }else{
        this.$toasted.show("Champs obligatoires!", this.ToastTabError)

      }
    },

    toGoSinistreHistorique(){
      this.$router.push('/sinsitre/history')
    },

    showForm() {
      this.showFormSinistre = true,
          this.showEtapes = false
    },

    submit() {
      this.$refs.form.validate()
    },

    clsoeDetailsPopu() {
      this.ModalDetailsSinistre = false;
      this.valueProgressBar = 0
    },

    setDetailsSinistre(item) {
      if (item.etat == 'Pris en compte') {
        this.valueProgressBar = this.valueProgressBar + 40
      }

      if (item.etat == 'Résolu') {
        this.valueProgressBar = this.valueProgressBar + 60
      }

      this.DetailsSinistre = item;
      this.ModalDetailsSinistre = true

    },

    clear() {
      this.$refs.form.reset()
    },

    checkBranch(id) {

      Api().get('branche/check/' + id)
          .then(ret => {
            this.brancheCheck = ret.data.nom
          })


    },

    //Recuperation des branches d'assurances pour declaration de sinistres
    GetAllBranche() {
      Api().get('branche')
          .then(response => {
            let assur = response.data
            //let assurance = assur[0]
// Filter to only get auto insurance branch
this.ListeBranche = assur.filter(branch => branch.branche === 'Automobile')

          })
    },

    //Recuperation des contrats de l'utilisateur pour declaration de sinistre
    GetUserContarts(val) {
      let v;
      const donnee = {
        userid: store.state.user._id,
        brancheid: val
      };
      Api().post('contrat/forsinistre', donnee)
          .then(response => {
            for (let index = 0; index < response.data.contrats.length; index++) {
              this.userContrat.push(response.data.contrats[index])
            }
            for(let i of this.userContrat){
              let dateExactly = 0;
              const date1 = dayjs(new Date().toISOString().substr(0, 10))
              const date2 = dayjs(i.dateEcheance)
              dateExactly = date1.diff(date2)

              if(dateExactly < 0){
                let autoInfo = i.details[0].vehicules[0].marque + " " + i.details[0].vehicules[0].model + " " + i.details[0].vehicules[0].immatriculation
                this.listAuto.push(autoInfo);
                v = {
                  "vehicule": autoInfo,
                  "numero_police": i.numero_police,
                  "id": i._id
                }
                this.listNumPolice.push(v)
                this.listAtoAll.push(autoInfo)
              }

               

              }
          })
    },

    ListingSinistre() {

      Api().get('sinistre/user/' + store.state.user._id)
          .then(response => {
            this.userSinistre = response.data.sinistres
          });
      this.ModalListeSinistre = true

    },

    //Envois des donnees du sinistres sur l'API
    DeclarationSinistre() {
      if(this.brancheCheck == 'Automobile' && this.PartieAdverse == 'Oui'){
        if (this.NomPrenom && this.phone && this.assureA && this.policyAdverse && this.validite && this.marque && this.model && this.puissance && this.usage && this.immatricule && this.passager) {
          let filePhoto = this.$refs.SinistrePhoto.files;
          let filePDF = this.$refs.SinistrePV.files[0];

          if(this.forceFiscaleValue != null){
            this.puissance = this.forceFiscaleValue
          }

          const vehicule = {
            marque: this.marque,
            model: this.model,
            puissance: this.puissance,
            usage: this.usage,
            visite: this.visite,
            immatricule: this.immatricule,
          };

          let formData = new FormData();

          formData.append("user", store.state.user._id);
          formData.append("assurance", this.assurance);
          formData.append("policeContrat", this.idC);
          formData.append("dateSurvenance", this.dateSurvenance);
          formData.append("dateDeclarationClient", this.date_declaration_client);
          formData.append("heureSurvenance", this.heureSurvenance);
          formData.append("dommage", this.dommage);
          formData.append("Details_Dommages", this.Details_Dommages);
          formData.append("Circonstance_Sinistres", this.Circonstance_Sinistres);
          formData.append("mandat", this.mandat);
          formData.append("document", this.selectedDoc);
          formData.append("PartieAdverse", this.PartieAdverse);
          formData.append("vehiculeAdverse", vehicule);
          formData.append("NomPrenom", this.NomPrenom);
          formData.append("adresse", this.adresse);
          formData.append("profession", this.profession);
          formData.append("assureA", this.assureA);
          formData.append("policyAdverse", this.policyAdverse);
          formData.append("validite", this.validite);
          formData.append("passager", this.passager);
          formData.append("filePDF", filePDF);

          for (let index = 0; index < filePhoto.length; index++) {
            let file = filePhoto[index];
            formData.append("image[" + index + "]", file);
          }


          /*================ vehicule Advers segmentation (because of Formdata) =================*/
          if (this.brancheCheck == 'Automobile') {
              /*================ vehicule Client segmentation (because of Formdata) =================*/
              formData.append("marqueClient", this.vehiculeClient.marque);
              formData.append("modelClient", this.vehiculeClient.model);
              formData.append("puissanceClient", this.force);
              formData.append("nbplace", this.vehiculeClient.nbplace);
              formData.append("valeur", this.vehiculeClient.valeur);
              formData.append("valeur_venale", this.vehiculeClient.valeur_venale);
              formData.append("carburation", this.vehiculeClient.carburation);
              formData.append("immatriculeClient", this.vehiculeClient.immatriculation);
              formData.append("categorie", this.vehiculeClient.categorie);

            if (this.PartieAdverse == "Oui") {
              formData.append("marqueAdverse", vehicule.marque);
              formData.append("modelAdverse", vehicule.model);
              formData.append("puissanceAdverse", vehicule.puissance);
              formData.append("usageAdverse", vehicule.usage);
              formData.append("visiteAdverse", vehicule.visite);
              formData.append("immatriculeAdverse", vehicule.immatricule);
            }
          }

          Api().post('sinistre/create', formData, {headers: {"Content-Type": "multipart/form-data"}})
              .then(response => {
                if (response.data.msgsucc) {
                  document.getElementById("secondStep").classList.add('checked');
                  document.getElementById("testup").classList.add('widthThirt');
                  this.$toasted.show(response.data.msgsucc, this.ToastTabSucess);
                  this.VoidForm();
                  setTimeout(() => (this.$router.push('/sinistre/success')), 3000)
                } else if (response.data.msgerr) {
                  this.$toasted.show(response.data.msgerr, this.ToastTabError)
                }
              })
        } else {
          this.$toasted.show("Remplir tous les champs obligatojres !", this.ToastTabError)
        }
      }
      else if(this.brancheCheck == 'Automobile' && this.PartieAdverse == 'Non'){
        let filePhoto = this.$refs.SinistrePhoto.files;
        let filePDF = this.$refs.SinistrePV.files[0];

        let formData = new FormData();

        const vehicule = {
          marque: 'N.A',
          model: 'N.A',
          puissance: 'N.A',
          usage: 'N.A',
          visite: 'N.A',
          immatricule: 'N.A',
        };

        formData.append("user", store.state.user._id);
        formData.append("assurance", this.assurance);
        formData.append("policeContrat", this.idC);
        formData.append("dateSurvenance", this.dateSurvenance);
        formData.append("dateDeclarationClient", this.date_declaration_client);
        formData.append("heureSurvenance", this.heureSurvenance);
        formData.append("dommage", this.dommage);
        formData.append("Details_Dommages", this.Details_Dommages);
        formData.append("Circonstance_Sinistres", this.Circonstance_Sinistres);
        formData.append("mandat", this.mandat);
        formData.append("document", this.selectedDoc);
        formData.append("PartieAdverse", this.PartieAdverse);
        formData.append("vehiculeAdverse", vehicule);
        formData.append("NomPrenom", this.NomPrenom);
        formData.append("adresse", this.adresse);
        formData.append("profession", this.profession);
        formData.append("assureA", this.assureA);
        formData.append("policyAdverse", this.policyAdverse);
        formData.append("validite", this.validite);
        formData.append("passager", this.passager);
        formData.append("filePDF", filePDF);



        for (let index = 0; index < filePhoto.length; index++) {
          let file = filePhoto[index];
          formData.append("image[" + index + "]", file);
        }
        /*================ vehicule Advers segmentation (because of Formdata) =================*/


        if (this.brancheCheck == 'Automobile') {
          console.log("véhicule client",this.vehiculeClient.marque)
          /*================ vehicule Client segmentation (because of Formdata) =================*/
          formData.append("marqueClient", this.vehiculeClient.marque);
          formData.append("modelClient", this.vehiculeClient.model);
          formData.append("puissanceClient", this.force);
          formData.append("nbplace", this.vehiculeClient.nbplace);
          formData.append("valeur", this.vehiculeClient.valeur);
          formData.append("valeur_venale", this.vehiculeClient.valeur_venale);
          formData.append("carburation", this.vehiculeClient.carburation);
          formData.append("immatriculeClient", this.vehiculeClient.immatriculation);
          formData.append("categorie", this.vehiculeClient.categorie);

          if (this.PartieAdverse == "Non") {
              formData.append("marqueAdverse", vehicule.marque);
              formData.append("modelAdverse", vehicule.model);
              formData.append("puissanceAdverse", vehicule.puissance);
              formData.append("usageAdverse", vehicule.usage);
              formData.append("visiteAdverse", vehicule.visite);
              formData.append("immatriculeAdverse", vehicule.immatricule);
            }
        }
        Api().post('sinistre/create', formData, {headers: {"Content-Type": "multipart/form-data"}})
            .then(response => {
              if (response.data.msgsucc) {
                document.getElementById("secondStep").classList.add('checked');
                document.getElementById("testup").classList.add('widthThirt');
                this.$toasted.show(response.data.msgsucc, this.ToastTabSucess);
                this.VoidForm();
                setTimeout(() => (this.$router.push('/sinistre/success')), 3000)
              } else if (response.data.msgerr) {
                this.$toasted.show(response.data.msgerr, this.ToastTabError)
              }
            })
      }
    },

    firstStepControl(){
      if(this.assurance && this.policy){
        if(this.dateSurvenance && this.heureSurvenance){
          this.NextStep = true
          this.step = 1
          this.next= false
          document.getElementById("testup").classList.add('widthFirst');
           for(let item of this.ListeVehicule){
            this.vehiculeClient = item;
           }
        }else {
          this.$toasted.show("Date et heure de survenance du sinistre obligatoires!", this.ToastTabError)
        }
      }else{
        this.$toasted.show("Type d'assurance et numéro de police obligatoires!", this.ToastTabError)
      }
    },

    secondStepControl() {
      if(this.$refs.SinistrePhoto.files[0] && this.$refs.SinistrePV.files[0] && this.mandat && this.dommage && this.Circonstance_Sinistres && this.Details_Dommages){
        let filePhoto = this.$refs.SinistrePhoto.files[0];
        let filePDF = this.$refs.SinistrePV.files[0];
        document.getElementById("firstStep").classList.add('checked');
        document.getElementById("testup").classList.add('widthSecond');
        this.step = 2
      }else{
        this.$toasted.show("Champs obligatoires!", this.ToastTabError)
      }
    },

    returnToFistStep() {
      document.getElementById("testup").classList.remove('widthFirst');
      this.step = 0
    },

    returnToSecondStep(){
      document.getElementById("firstStep").classList.remove('checked');
      document.getElementById("testup").classList.remove('widthSecond');
      this.step = 1
    },

    /* Retourne true ou false si nous sommes sur un mobile */
    isMobile: function () {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },

    GetAllUserDocument() {
      Api().get('userdocument/getall/' + store.state.user._id)
          .then(response => {
            this.userDocument = response.data.documentLink
          })
    },

    getListVehiculeByIdContrat(idC) {
      Api().get('sinistre/contratauto/' + idC)
          .then(rep => {
            this.ListeVehicule = rep.data.ListeVehicule;
            // this.dialogListeVehicule = true
          }).catch(e => {
      })
    },

    // Mis a null des champs du formaulaire apres validation
    VoidForm() {
      this.NomPrenom = "";
      this.profession = "";
      this.policyAdverse = "";
      this.validite = "";
      this.model = "";
      this.marque = "";
      this.puissance = "";
      this.usage = "";
      this.visite = "";
      this.immatricule = "";
      this.assurance = "";
      this.policy = "";
      this.dateSurvenance = "";
      this.heureSurvenance = "";
      this.dommage = "";
      this.Circonstance_Sinistres = "";
      this.Details_Dommages = ""
    },

    DateFormater: function (TheDate) {
      if (TheDate) {
        return dayjs(TheDate).format('DD-MM-YYYY')
      }
    },

    ChoosingDoc(doc) {
      let nomDoc = doc.lien_document.split('userdocuments/');
      this.selectedDoc = doc.lien_document;
      this.displayDoc = nomDoc[1];
      this.LoadDocumentList = false
    },

    /* Retourne true ou false si nous sommes sur un PC */
    isDesktop: function () {
      if (screen.width > 760) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.GetAllBranche();
    this.GetAllUserDocument()
  }

}
</script>

<style lang="less" scoped>
@import "../../assets/css/button.css";
@import "../../assets/css/devis_css.css";


input[type=time] {
  border: 1px solid #D9DEE3;
  color: #2a2c2d;
  font-size: 13px;
  font-family: helvetica;
  width: 100%;
  border-radius: 10px;
  background: #fff;
}

/* Wrapper around the hour, minute, second, and am/pm fields as well as
the up and down buttons and the 'X' button */
input[type=time]::-webkit-datetime-edit-fields-wrapper {
  display: flex;
}

/* The space between the fields - between hour and minute, the minute and
second, second and am/pm */
input[type=time]::-webkit-datetime-edit-text {
  padding: 19px 4px;
}

/* The naming convention for the hour, minute, second, and am/pm field is
`-webkit-datetime-edit-{field}-field` */

/* Hour */
input[type=time]::-webkit-datetime-edit-hour-field {
  background-color: #f2f4f5;
  border-radius: 15%;
  padding: 19px 13px;
  margin-left: 10px;
}

/* Minute */
input[type=time]::-webkit-datetime-edit-minute-field {
  background-color: #f2f4f5;
  border-radius: 15%;
  padding: 19px 13px;
  margin-left: 10px;
}

/* AM/PM */
input[type=time]::-webkit-datetime-edit-ampm-field {
  background-color: #ffa409;
  border-radius: 15%;
  color: #fff;
  padding: 19px 13px;
}

/* 'X' button for resetting/clearing time */
input[type=time]::-webkit-clear-button {
  display: none;
}

/* Up/Down arrows for incrementing/decrementing the value */
input[type=time]::-webkit-inner-spin-button {
  display: none;
}


.borderRadius {
  border-radius: 15px;
  border: 2px solid #ffa409 !important;
}

.selectatDesktop {
  border-radius: 15px;
  background: url(https://) no-repeat right;
  -webkit-appearance: none;
  background-position-x: 680px;
  border: 2px solid lightgrey !important;
}

.selectatMobile {
  border-radius: 15px;
  background: url(https://) no-repeat right;
  -webkit-appearance: none;
  background-position-x: 93%;
  border: 2px solid lightgrey !important;
}

.ListStyle li {
  list-style: none
}

.file-btn {
  color: #ffa409 !important;
  text-transform: lowercase;
}

.border-round {
  border: 1px solid grey;
  border-radius: 10px;
}

.form {
  margin-top: -60px;
}

.format {
  margin-left: -70px;
  width: 300px;
  margin-top: -50px;
}

.premier {
  /* max-width: 1200px; */
  margin: auto;
  margin-top: 100px;
}

.detail {
  color: grey;
  margin-left: 80px;
}

.mobile {
  margin-left: 2px;
  margin-right: 2px;
  margin-bottom: 10px;
}

.dom {
  color: grey;
  margin-right: 0px;
  margin-top: 20px;
}

.file {
  width: 500px;
  margin-bottom: 50px;
  margin-left: 16%;
}

.list-boutons li {
  text-decoration: none !important;
  list-style: none;
}


.list-boutons li .link-btn:hover {
  text-decoration: none !important;
  color: white !important;
}


.assuraf-text-color {
  color: #ffa409;
}


.sinistre {
  margin-left: 150px;
  margin-top: 10px;
  margin-bottom: 50px;


}

/* ==================CSS SINISTRE FORM MOBILE============== */
.border-radius {
  border-radius: 20px !important
}

.georgia {
  font-family: georgia !important;
}
.policeLato {
  font-family: Lato, "Helvetica Neue", Arial, sans-serif
}

.scroll {
  max-height: 450px;
  overflow-y: auto !important;
}






.p-4{
  background: #D8D8D8!important;
  color: black;
  padding: 0.5rem!important;
}
.comment{
  background: white!important;
  width: 100%;
  height: 100px;
  padding: 0;
}

.paralax-cover-image {
  background-image: url('../../assets/img/assurance/sinistre.jpg');
  position: relative;
  background-size: contain!important;
  background-position: 50%;
  min-height: 230px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image {
  background-attachment: fixed;
  background-position: 50% 50px;
}


.paralax-cover-image_mobile {
  background-image: url('../../assets/img/assurance/sinistre_mobile.jpg');
  position: relative;
  background-size: contain;
  background-position: 50%;
  min-height: 150px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
//padding: 20px;
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image_mobile p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  padding-bottom: 20Px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image_mobile {
  // background-attachment: fixed;
  background-position: 100% 40px;
}

.container_forma {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.file-upload-wrapper {
  border: 1px solid #d9dee3;
  border-radius: 5px;
  position: relative;
  width: 100%;
  height: 55px;
}
.file-upload-wrapper:after {
  content: attr(data-text);
  font-size: 18px;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  padding: 10px 15px;
  display: block;
  width: calc(100%);
  pointer-events: none;
  z-index: 20;
  height: 40px;
  line-height: 40px;
  color: #999;
  border-radius: 5px 10px 10px 5px;
  font-weight: 300;
}
.file-upload-wrapper:before {
  content: 'Ajouter';
  position: absolute;
  top: -1px;
  right: -2px;
  display: inline-block;
  height: 55px;
  background: #acabab;
  color: #fff;
  font-weight: 700;
  z-index: 25;
  font-size: 16px;
  line-height: 60px;
  padding: 0 15px;
  text-transform: capitalize;
  pointer-events: none;
  border-radius: 0 5px 5px 0;
}
.file-upload-wrapper:hover:before {
  background: #ffa409;
}
.file-upload-wrapper input {
  opacity: 0;
  border: 2px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  height: 40px;
  margin: 0;
  padding: 0;
  display: block;
  cursor: pointer;
  width: 100%;
}

.widthFirst{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:23.55556%;
}
.widthSecond{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:50.11112%;
}
.widthThirt{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:100%;
}




/*



section{
  display: flex;
  flex-direction: column;
  //padding: 0.5em;
  margin-top: -3px;
}

input[type='checkbox']{ height: 0; width: 0; }

input[type='checkbox'] + label{
  position: relative;
  display: flex;
  margin: .3em 0;
  align-items: center;
  color: #9e9e9e;
  transition: color 250ms cubic-bezier(.4,.0,.23,1);
  font-size: 2rem;
}
input[type='checkbox'] + label > ins{
  position: absolute;
  display: block;
  bottom: 0;
  left: 2em;
  height: 0;
  width: 100%;
  overflow: hidden;
  text-decoration: none;
  transition: height 300ms cubic-bezier(.4,.0,.23,1);
}
input[type='checkbox'] + label > ins > i{
  position: absolute;
  bottom: 0;
  font-style: normal;
  color: #ffa409;
}
input[type='checkbox'] + label > span{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 1em;
  width: 1em;
  height: 1em;
  background: transparent;
  border: 2px solid #9E9E9E;
  border-radius: 3px;
  cursor: pointer;
  transition: all 250ms cubic-bezier(.4,.0,.23,1);
}

input[type='checkbox'] + label:hover, input[type='checkbox']:focus + label{
  color: #ffa409;
}
input[type='checkbox'] + label:hover > span, input[type='checkbox']:focus + label > span{
  background: rgba(255,255,255,.1);
}
input[type='checkbox']:checked + label > ins{ height: 100%; }

input[type='checkbox']:checked + label > span{
  border: .5em solid #ffa409;
  animation: shrink-bounce 200ms cubic-bezier(.4,.0,.23,1);
}
input[type='checkbox']:checked + label > span:before{
  content: "";
  position: absolute;
  top: .6em;
  left: .2em;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
  transform: rotate(45deg);
  transform-origin: 0% 100%;
  animation: checkbox-check 125ms 250ms cubic-bezier(.4,.0,.23,1) forwards;
}

@keyframes shrink-bounce{
  0%{
    transform: scale(1);
  }
  33%{
    transform: scale(.85);
  }
  100%{
    transform: scale(1);
  }
}
@keyframes checkbox-check{
  0%{
    width: 0;
    height: 0;
    border-color: #212121;
    transform: translate3d(0,0,0) rotate(45deg);
  }
  33%{
    width: .2em;
    height: 0;
    transform: translate3d(0,0,0) rotate(45deg);
  }
  100%{
    width: .2em;
    height: .5em;
    border-color: #212121;
    transform: translate3d(0,-.5em,0) rotate(45deg);
  }
}*/





/*== start of code for tooltips ==*/
.tool_button {
  cursor: help;
  position: relative;
}


/*== common styles for both parts of tool tip ==*/
.tool_button::before,
.tool_button::after {
  left: 50%;
  opacity: 0;
  position: absolute;
  z-index: -100;
}

.tool_button:hover::before,
.tool_button:focus::before,
.tool_button:hover::after,
.tool_button:focus::after {
  opacity: 1;
  transform: scale(1) translateY(0);
  z-index: 10000;
}


/*== pointer tip ==*/
.tool_button::before {
  border-style: solid;
  border-width: 1em 0.75em 0 0.75em;
  border-color: #565C61 transparent transparent transparent;
  bottom: 120%;
  content: "";
  margin-left: -0.5em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26), opacity .65s .5s;
  transform:  scale(.6) translateY(-90%);
}

.tool_button:hover::before,
.tool_button:focus::before {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
}



/*== speech bubble ==*/
.tool_button::after {
  background: #565C61;
  border-radius: .25em;
  bottom: 176%;
  color: #EDEFF0;
  font-size:15px;
  content: attr(data-tip);
  margin-left: -8.75em;
  padding: 1em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
  transform:  scale(.6) translateY(50%);
  width: 11.5em;

}

.tool_button:hover::after,
.tool_button:focus::after  {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26);
}

@media (max-width: 760px) {
  .tool_button::after {
    font-size: .75em;
    margin-left: -5em;
    width: 10em;
  }
}


















.exp {
  display: table;
  margin-top: 12px;
  height: 100%;
}
.exp .checkbox {
  display: table-cell;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  text-align: center;
}
.label_name {
  display: inline-block;
  font-weight: 300;
  color: grey;
  cursor: pointer;
  position: relative;
  font-size: 20px;
}
.label_name .spanCheckbox {
  display: inline-block;
  position: relative;
  background-color: transparent;
  width: 25px;
  height: 25px;
  transform-origin: center;
  border: 2px solid #ffa409;
  border-radius: 50%;
  vertical-align: -6px;
  margin-right: 10px;
  transition: background-color 150ms 200ms, transform 350ms cubic-bezier(0.78, -1.22, 0.17, 1.89);
}
.label_name .spanCheckbox:before {
  content: "";
  width: 0px;
  height: 2px;
  border-radius: 2px;
  background: #ffa409;
  position: absolute;
  transform: rotate(45deg);
  top: 10px;
  left: 6px;
  transition: width 50ms ease 50ms;
  transform-origin: 0% 0%;
}
.label_name .spanCheckbox:after {
  content: "";
  width: 0;
  height: 2px;
  border-radius: 2px;
  background: #ffa409;
  position: absolute;
  transform: rotate(305deg);
  top: 13px;
  left: 8px;
  transition: width 50ms ease;
  transform-origin: 0% 0%;
}
.label_name:hover .spanCheckbox:before {
  width: 5px;
  transition: width 100ms ease;
}
.label_name:hover .spanCheckbox:after {
  width: 10px;
  transition: width 150ms ease 100ms;
}
input[type="checkbox"] {
  display: none;
}
input[type="checkbox"]:checked + .label_name .spanCheckbox {
  background-color: #fff;
  transform: scale(1.25);
}
input[type="checkbox"]:checked + .label_name .spanCheckbox:after {
  width: 10px;
  background: #ffa409;
  transition: width 150ms ease 100ms;
}
input[type="checkbox"]:checked + .label_name .spanCheckbox:before {
  width: 5px;
  background: #ffa409;
  transition: width 150ms ease 100ms;
}
input[type="checkbox"]:checked + .label_name:hover .spanCheckbox {
  background-color: #fff;
  transform: scale(1.25);
}
input[type="checkbox"]:checked + .label_name:hover .spanCheckbox:after {
  width: 10px;
  background: #ffa409;
  transition: width 150ms ease 100ms;
}
input[type="checkbox"]:checked + .label_name:hover .spanCheckbox:before {
  width: 5px;
  background: #ffa409;
  transition: width 150ms ease 100ms;
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
</style>
